import React from "react";

import { faChartSimple } from "@fortawesome/pro-solid-svg-icons/faChartSimple";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Tooltip from "antd/es/tooltip";
import { MessageDescriptor, useIntl } from "react-intl";

import { EntityTypeIcon } from "@mapmycustomers/ui";

import {
  CHART_MENTION_MARKER,
  markerToEntityType,
  MentionMarkerType,
} from "../util/parseEntityMentions";

import messages from "./messages";
import styles from "./UnavailableMentionPill.module.scss";

const UNAVAILABLE_MESSAGES: Record<
  MentionMarkerType | typeof CHART_MENTION_MARKER,
  [label: MessageDescriptor, tooltip: MessageDescriptor]
> = {
  account: [messages.company, messages.companyTooltip],
  "account-group": [messages.group, messages.groupTooltip],
  chart: [messages.chart, messages.chartTooltip],
  contact: [messages.person, messages.personTooltip],
  "contact-group": [messages.group, messages.groupTooltip],
  deal: [messages.deal, messages.dealTooltip],
  "deal-group": [messages.group, messages.groupTooltip],
  territory: [messages.territory, messages.territoryTooltip],
  "unified-route": [messages.route, messages.routeTooltip],
  user: [messages.user, messages.userTooltip],
};

export interface UnavailableMentionPillProps {
  type: MentionMarkerType | typeof CHART_MENTION_MARKER;
}

const UnavailableMentionPill = ({ type }: UnavailableMentionPillProps) => {
  const intl = useIntl();
  const [label, tooltip] = UNAVAILABLE_MESSAGES[type];
  return (
    <Tooltip title={intl.formatMessage(tooltip)}>
      <span className={styles.unavailablePill}>
        {type === CHART_MENTION_MARKER ? (
          <FontAwesomeIcon className={styles.icon} icon={faChartSimple} />
        ) : (
          <EntityTypeIcon className={styles.icon} entityType={markerToEntityType(type)} />
        )}
        {intl.formatMessage(label)}
      </span>
    </Tooltip>
  );
};

export default UnavailableMentionPill;
